import { Box } from '@mui/material';
import styles from './AppLogo.module.scss';

export default function AppLogo (){
    return (<Box className={styles.container}>
        <img className={styles.logoBackground} alt='Logo CenteCaribe' src={`${process.env.PUBLIC_URL}/img/main_logo.png`}/>
    </Box>);
}